webpackJsonp([53125558880568],{

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(9);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Divider = __webpack_require__(6);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Fill = __webpack_require__(5);
	
	var _Fill2 = _interopRequireDefault(_Fill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var query = exports.query = '** extracted graphql fragment **';
	
	var CaseStudies = function CaseStudies(_ref) {
	  var _ref$data = _ref.data,
	      cone = _ref$data.cone,
	      ctwo = _ref$data.ctwo,
	      cthree = _ref$data.cthree;
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'block' } },
	            _react2.default.createElement(
	              'h1',
	              { className: 'smallerHone' },
	              'Case Study'
	            ),
	            _react2.default.createElement('img', { src: _Divider2.default, alt: 'Nisadhya - Divider', style: { margin: '.75rem 0' } }),
	            _react2.default.createElement(
	              'p',
	              { className: 'smallerHone' },
	              _react2.default.createElement(
	                'span',
	                { className: 'gradient' },
	                'Case studies such as these inspire and motivate us.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'See how businesses similar to yours are growing with Digital Marketing.'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              'We have been in existence in the digital market field for 2 and half years. Knowing that the digital market and business is growing exponentially, Nisadhya has become a leader in digital marketing where we have worked with more than 15 clients fostering their growth and successfully solving their problems.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container', style: { paddingTop: '0' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'full-Width', style: { alignItems: 'flex-start', justifyContent: 'space-between' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30 mobBottommargin' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case-studies' },
	              _react2.default.createElement(
	                'div',
	                { style: { overflow: 'hidden' } },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/case-studies/kcl-astute/' },
	                  _react2.default.createElement(_gatsbyImage2.default, { className: 'case-studies-img', sizes: cone.conechild.sizes, alt: ' KCL Astute Capital Limited' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { padding: '1.0875rem' } },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'smallerHone' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'gradient' },
	                    'KCL Astute.'
	                  )
	                ),
	                _react2.default.createElement('img', { src: _Fill2.default, alt: 'Nisadhya - Divider', style: { margin: '.75rem 0' } }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'KCL Astute Capital Limited is a Merchant Banker licensed by Securities Board of Nepal (SEBON) to render Portfolio Management Services.'
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/case-studies/kcl-astute/', className: 'slide gradient' },
	                  'View Case Study'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case-studies' },
	              _react2.default.createElement(
	                'div',
	                { style: { overflow: 'hidden' } },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/case-studies/wanderthirst-hostels/' },
	                  _react2.default.createElement(_gatsbyImage2.default, { className: 'case-studies-img', sizes: cthree.cthreechild.sizes, alt: 'WanderThirst Hostels' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { padding: '1.0875rem' } },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'smallerHone' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'gradient' },
	                    'WanderThirst Hostels.'
	                  )
	                ),
	                _react2.default.createElement('img', { src: _Fill2.default, alt: 'Nisadhya - Divider', style: { margin: '.75rem 0' } }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'WanderThirst Hostels cater towards backpackers and travellers from all around the world who seek accommodation for an affordable budget.'
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/case-studies/wanderthirst-hostels/', className: 'slide gradient' },
	                  'View Case Study'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'half-Width-30' })
	        )
	      )
	    )
	  );
	};
	
	exports.default = CaseStudies;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-case-studies-index-js-2e1fd06be828f435913c.js